import React from "react";
import "../styles/aratext.css";
import subeImage from "../assets/sube/1340x205.jpg";

const Aratext: React.FC = () => {
  return (
    <div className="banner">
      <img src={subeImage} alt="Şube Banner" style={{ width: "100%", height: "auto" }} />
    </div>
  );
};

export default Aratext;
